import type { CSSProperties } from "react";
import { Check } from "lucide-react";
import type { Accent } from "@dfws/contracts";
import { accents } from "../../settings/accents";
import s from "./Settings.module.css";

/** Native radios, so arrow keys, focus and screen readers behave like any radio group. */
export function AccentPicker({ value, onChange }: { value: Accent; onChange: (a: Accent) => void }) {
  return (
    <div role="radiogroup" aria-label="Accent color" className={s.accents}>
      {accents.map((a) => (
        <label key={a.id} className={s.accent} style={{ "--sw-light": a.swatch.light, "--sw-dark": a.swatch.dark } as CSSProperties}>
          <input type="radio" name="accent" value={a.id} checked={value === a.id} onChange={() => onChange(a.id)} className={s.accentInput} />
          <span className={s.swatch} aria-hidden="true">
            <Check />
          </span>
          <span className={s.accentName}>{a.label}</span>
        </label>
      ))}
    </div>
  );
}
